(function () {
  var selector = 'img[data-ps-deferred-image]';

  function matches(el, match) {
    var fn;

    if (!el || el.nodeType !== 1) {
      return false;
    }

    fn = el.matches || el.matchesSelector || el.msMatchesSelector || el.webkitMatchesSelector || el.mozMatchesSelector;
    return fn ? fn.call(el, match) : false;
  }

  function closest(el, match) {
    while (el && el.nodeType === 1) {
      if (matches(el, match)) {
        return el;
      }
      el = el.parentNode;
    }
    return null;
  }

  function hydrateImage(img) {
    var src;
    var srcset;

    if (!img || img.getAttribute('data-ps-deferred-loaded') === 'true') {
      return;
    }

    srcset = img.getAttribute('data-ps-srcset');
    src = img.getAttribute('data-ps-src');

    if (srcset) {
      img.setAttribute('srcset', srcset);
      img.removeAttribute('data-ps-srcset');
    }

    if (src) {
      img.setAttribute('src', src);
      img.removeAttribute('data-ps-src');
    }

    img.setAttribute('data-ps-deferred-loaded', 'true');
    img.removeAttribute('data-ps-deferred-image');
  }

  function hydrateWithin(root) {
    var images;
    var i;

    if (!root) {
      return;
    }

    if (matches(root, selector)) {
      hydrateImage(root);
    }

    images = root.querySelectorAll ? root.querySelectorAll(selector) : [];
    for (i = 0; i < images.length; i += 1) {
      hydrateImage(images[i]);
    }
  }

  function hydrateMediaTarget(control) {
    var item;
    var gallery;
    var mediaId;
    var slide;

    item = closest(control, '[data-target]');
    if (!item) {
      return;
    }

    hydrateWithin(item);
    mediaId = item.getAttribute('data-target');
    gallery = closest(item, 'media-gallery');
    if (!gallery || !mediaId) {
      return;
    }

    slide = gallery.querySelector('[data-media-id="' + mediaId + '"]');
    hydrateWithin(slide);
  }

  function hydrateProductModal(control) {
    var opener;
    var modalId;
    var modal;

    opener = closest(control, '[data-modal]');
    if (!opener) {
      return;
    }

    modalId = opener.getAttribute('data-modal');
    if (!modalId || modalId.indexOf('#ProductModal-') !== 0) {
      return;
    }

    modal = document.querySelector(modalId);
    hydrateWithin(modal);
  }

  function onInteraction(event) {
    hydrateMediaTarget(event.target);
    hydrateProductModal(event.target);
  }

  function initObserver() {
    var images = document.querySelectorAll(selector);
    var observer;
    var i;

    if (!images.length) {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      for (i = 0; i < images.length; i += 1) {
        hydrateImage(images[i]);
      }
      return;
    }

    observer = new IntersectionObserver(function (entries) {
      var j;
      var img;

      for (j = 0; j < entries.length; j += 1) {
        if (entries[j].isIntersecting || entries[j].intersectionRatio > 0) {
          img = entries[j].target;
          observer.unobserve(img);
          hydrateImage(img);
        }
      }
    }, {
      root: null,
      rootMargin: '600px 600px',
      threshold: 0.01
    });

    for (i = 0; i < images.length; i += 1) {
      observer.observe(images[i]);
    }
  }

  function init() {
    initObserver();
    document.addEventListener('click', onInteraction, true);
    document.addEventListener('focusin', onInteraction, true);
    document.addEventListener('mouseover', onInteraction, true);
    document.addEventListener('touchstart', onInteraction, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
